import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductReview } from '@features/product/interfaces/product-review.interface';
import { UserProductReview } from '@features/user/interfaces/user-product-review.interface';
import { UserReviewProductService } from '@features/user/services/user-review-product';
import {
  faChevronDown,
  faSpinner,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'fc-user-review-product-history',
  templateUrl: './user-review-product-history.component.html',
  styleUrls: ['./user-review-product-history.component.css'],
})
export class UserReviewProductHistoryComponent implements OnInit {
  faChevronDown = faChevronDown;
  faSpinner = faSpinner;
  faStar = faStar;

  totalItems = 0;
  reviews: UserProductReview[] = [];
  currentPage = 0;

  shopDefaultImg = 'assets/images/shop/shop-logo.png';
  productDefaultImg: string = 'assets/images/product/default-product.png';

  hideLoadMore = true;
  loadMoreLoading = false;

  imgSwiperConfig: SwiperOptions = {
    slidesPerView: 'auto',
    loop: false,
    loopedSlides: 1,
    freeMode: true,
    watchOverflow: true,
  };

  constructor(
      private userReviewProductService: UserReviewProductService,
      private router: Router,
      private layoutService: LayoutService,
    ) {}

  ngOnInit(): void {
    this.loadReview();
  }

  loadReview() {
    this.currentPage += 1;
    this.loadMoreLoading = true;
    this.userReviewProductService
      .getReviewHistory(5, this.currentPage)
      .subscribe(
        (data: any) => {
          console.log(data)
          this.totalItems = data.totalItems;
          data.reviews.map((rv: any) => this.reviews.push(rv));
          this.loadMoreLoading = false;
          this.hideLoadMore = this.reviews.length >= data.totalItems;
        },
        (error) => {
          this.loadMoreLoading = false;
        }
      );
  }

  handleShopImgError() {
    this.shopDefaultImg = 'assets/images/shop/shop-logo.png';
  }
  handleProductImgError() {
    this.productDefaultImg = 'assets/images/product/default-product.png';
  }

  navigateToProductDetail(productReview: ProductReview){
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/product', productReview.product.slug]));
  }

}
